import planificationEscl from '../../../locales/es-CL/planification.json';
import planificationEsmx from '../../../locales/es-MX/planification.json';
import planificationEsco from '../../../locales/es-CO/planification.json';
import planificationEnus from '../../../locales/en-US/planification.json';

export default {
  name: 'ProgressBar',
  props: {
    stepPlanification: {
      type: String,
      default: 'operation',
    },
  },
  i18n: {
    messages: {
      'es-CL': {
        planification: planificationEscl,
      },
      'es-MX': {
        planification: planificationEsmx,
      },
      'es-CO': {
        planification: planificationEsco,
      },
      'en-US': {
        planification: planificationEnus,
      },
    },
  },
  data() {
    return {
      //Secciones
      isOperationSection: false,
      isDateSection: true,
      isPlanificationSection: false,
      isRouteSection: false,
      //Estados ready
      isReadyOperation: false,
      isReadyDate: false,
      isReadyPlanification: false,
      isReadyRoutes: false,
      currentStep: 'operation',
    };
  },
  created() {
    this.changeProgress();
  },
  methods: {
    changeProgress() {
      const validSteps = ['operation', 'date', 'resources', 'routes'];
      this.currentStep = validSteps.includes(this.stepPlanification) ? this.stepPlanification : 'operation';
    },
    getStepImage(index, step) {
      if (!step.isActive && !step.isReady) {
        return require(`../../../assets/planificationSteps/Paso${index + 1}.svg`);
      } else if (step.isActive && !step.isReady) {
        return require(`../../../assets/planificationSteps/Paso${index + 1}Check.svg`);
      } else {
        return require('../../../assets/planificationSteps/checkStep.svg');
      }
    },
  },
  computed: {
    steps() {
      const order = ['operation', 'date', 'resources', 'routes'];
      const currentIndex = order.indexOf(this.currentStep);
      return order.map((step, index) => ({
        name: step,
        isActive: index === currentIndex,
        isReady: index < currentIndex,
      }));
    },
  },
  watch: {
    stepPlanification() {
      this.changeProgress();
    },
  },
};
